import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { getEnvVar } from '@/utils/env-utils/envUtils';
import * as LDClient from 'launchdarkly-js-client-sdk';

type LaunchDarklyContextType = LDClient.LDClient | null;
const API_KEY = getEnvVar('VITE_LAUNCH_DARKLY_CLIENT_ID') as string;
const LaunchDarklyContext = createContext<LaunchDarklyContextType>(null);

export const useLaunchDarkly = (): LDClient.LDClient | null => {
  return useContext(LaunchDarklyContext);
};

interface LaunchDarklyProviderProps {
  children: ReactNode;
  userKey?: string;
  userName?: string;
  licenseeId?: string;
}

export const LaunchDarklyProvider = ({
  children,
  userKey = 'anonymous',
  userName = 'Anonymous User',
  licenseeId,
}: LaunchDarklyProviderProps) => {
  const [ldClient, setLdClient] = useState<LDClient.LDClient | null>(null);

  useEffect(() => {
    const user: LDClient.LDUser = {
      key: userKey,
      name: userName,
      anonymous: userKey === 'anonymous',
      custom: licenseeId
        ? {
            licenseeId: licenseeId,
          }
        : undefined,
    };

    const client = LDClient.initialize(API_KEY, user);

    client.on('ready', () => {
      setLdClient(client);
    });

    return () => {
      client?.close();
    };
  }, [userKey, userName, licenseeId]);

  if (!ldClient) return null;

  return <LaunchDarklyContext.Provider value={ldClient}>{children}</LaunchDarklyContext.Provider>;
};
